// auth.js — SSO über mednos.eu: Das Session-Cookie `mednos_session` kommt
// bei Same-Origin-Requests automatisch mit. Kein localStorage-Token, keine
// Authorization-Header mehr — nur noch Session-Check + Redirect zur Landing.

const LANDING = 'https://mednos.eu';

/**
 * Prüft die Session. Bei fehlender/abgelaufener Session Redirect zur
 * Landing-Page (mednos.eu) mit Rücksprung-URL.
 * Rückgabe: Session-Info, { devMode: true } bei Dev-Bypass, null bei Redirect.
 */
export async function requireAuth() {
  const cfg = await fetch('/api/auth/config')
    .then((r) => r.json())
    .catch(() => ({}));
  if (cfg.auth_required === false) return { devMode: true };

  try {
    const res = await fetch('/api/auth/verify', { credentials: 'same-origin' });
    if (res.ok) return await res.json();
  } catch (error) {
    // Netzwerkfehler: nicht umleiten, Offline-Nutzung zulassen
    console.error('Session-Prüfung fehlgeschlagen:', error);
    return { offline: true };
  }

  window.location.href = `${LANDING}/?redirect=${encodeURIComponent(window.location.href)}`;
  return null;
}

/**
 * Beendet die SSO-Session zentral auf mednos.eu und leitet zur Landing um.
 */
export async function logout() {
  // Die gemerkte Stelle in der Vault gehoert zur Sitzung, nicht zum Geraet.
  try {
    sessionStorage.removeItem('obsidian_last_file');
  } catch {
    // ohne Speicher gibt es auch nichts zu raeumen
  }
  try {
    await fetch(`${LANDING}/api/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch (error) {
    console.warn('Logout-Request fehlgeschlagen:', error);
  }
  window.location.href = LANDING;
}

// Kompatibilität: bestehende Aufrufer nutzen window.Auth
window.Auth = { requireAuth, logout };

// Session-Check beim Laden der App
requireAuth();
